import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../../common/inputStyleHelper";
import { resolveShipmentInputType, ensureShipmentInputDetector, INPUT_TYPE } from "../../../../common/shipmentInputTypeHelper";
import dummyInput from '../../common/smartInput.vue'

import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    getPendingforallocationList as pendingshipmentList,
    AllocatedShipmentDetails as AllocatedFwdShipmentDetails,
    ClientNameList as ClientNameList,
    validateEODAllocation as EODValidation,
    TriDetails as GetTripdetails,
    AllocateShipment as AllocateShipment,
    PreviousDayShipment as PreviousDayShipmentDetails,
    CloseTrip1 as CloseTrip,
    PendingList as PendingList2,
    VehicleList1 as VehicleList,
    CreateTrip as CreateTrip,
    GetSubcluster as SameRouteShipments,
    ShipmentConfirm as ConfirmShipment,
    ShipmentPrintDetails1 as ShipmentPrintDetails,
    pdfData1 as pdfData,
    getUnallocatedShipmentsByShipmentType as getUnallocatedShipments,
    RemoveAllocatedShipment1 as RemoveAllocatedShipment,
    GetShipmentCount1 as GetShipmentCount,
    SubmitReason1 as StoreReason,
    SeqofNonAllocation as GetNonAllocationSEQ,
    GetBikeVehicleList as BikeVehicleList,
    getallocationDashboardCount as getallocationDashboardCount,
    getallocationPendingCountList as getallocationPendingCountList,
    SeqofNonAllocationMobile as GetNonAllocationSEQMobile,
    SubmitReasonMobile1 as StoreReasonMobile,
    fetchAdhocVehicleList as AdhocVehicleList,
    getHubRoutingMode as getHubRoutingMode,
} from '../../../../../services/modules/newallocationservices.js'


import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments,
        Multiselect,
        'dummy-input': dummyInput
    },
    mixins: [PageTracker],
    props: {
        srList: Array,
        hubCODPendingLimit: { type: [String, Number]},
        IsPendingCODBlock: { type: [String, Boolean]},
        isRSVSr: { type: [String, Number]},
        ServiceTypeArrayList: Array,
        ServiceTypeList: Array,
        EscalationList: Array,
        ClusterList: Array,
        allocationrefreshflag: { type: [String, Number]},
        isSVCEnabledForAdhocVehicles: { type: [String, Boolean]},
        hyperVMsgData: Object,
        isScannerOnlyAllocationEnabled: { type: Boolean, default: false },
    },
    data: function() {
        return {
            userHubIdArr: [],
            isAutoRoutingMode: false,
            value: false,
            PDDPopup: false,
            vehiclePopup: false,
            currentScreenTab: 'ALL',
            CourierCompanyID: '',
            IsSRNeedTrip: false,
            // isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            EmpType: '',
            SRSelectingloader: false,
            srArrayList: [],
            // srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            clientList: [],
            clientArrayList: [],
            Clientname: '',
            ClientObj: {
                value: "",
                text: ""
            },
            Clientname2: '',
            ClientObj2: {
                value: "",
                text: ""
            },
            ClientLoader: '',
            ServiceType: '',
            // ServiceTypeArrayList: [],
            // ServiceTypeList: [],
            ServiceTypeObj: {
                value: "",
                text: ""
            },
            ServiceLoader: false,
            WeightGroup: '',
            WeightGList: [{
                    value: "0,1",
                    text: "All"
                },
                {
                    value: "1",
                    text: "Heavies"
                },
                {
                    value: "0",
                    text: "Regular"
                },
            ],
            WeightGObj: {},
            EscalationLoader: '',
            Escalation: '',
            // EscalationList: [],
            // EscalationListArrayList: [],
            EscalationObj: {
                value: "",
                text: ""
            },
            // ClusterLoader: '',
            ClusterId: '',
            // ClusterList: [],
            // ClusterArrayList: [],
            ClusterObj: {
                value: "",
                text: ""
            },
            shipmentNo: '',
            shipmentInputType: null,
            shipmentManualKeyThresholdMs: 300,
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],
            UnallocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingId",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "PDD Date",
                    key: "PDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Service Type",
                    key: "ServiceType",
                },
                {
                    label: "Payment Mode",
                    key: "OrderType",
                },
                {
                    label: "Amt",
                    key: "NetPayment",
                },
                // {
                //     label: "Cluster ID",
                //     key: "subclusterid",
                // },
                {
                    label: "SubCluster Name",
                    key: "subclustername",
                },
            ],
            AllocatedList: [],
            AllocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "EDD Date",
                    key: "EDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Service Type",
                    key: "ServiceType",
                },
                {
                    label: "Pincode",
                    key: "ShipPincode",
                },
            ],
            SuggestionList: [],
            SuggestionColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "EDD date",
                    key: "EDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },

            ],
            SameRouteColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "PDD date",
                    key: "PDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
            ],
            SameRouteList: [],
            startAllocationFlag: false,
            AllocateLoading: false,
            isAllocation: false,
            isConfirmLoad: false,
            dismissSecs: 20,
            dismissCountDown: 0,
            allocationErrorMsg: "",
            dismissCountDownSuccess: 0,
            allocationSuccessMsg: "",
            flagShowPreviousShipment: false,
            showShipmentModel: false,
            isPodsLoader: false,
            PendingList: [],
            showGroupIdShipmentModel: false,
            showParentGroupIdShipmentList: [],
            pendingGrouptErrorMsg: '',
            IsLongPinCodeFlag: null,
            ebnVehicleNo: '',
            errEbnVehicleNo: '',
            flagShowEbnVehicleNo: false,
            closeTripModel: false,
            startTripFlag: false,
            tripId: '',
            openKmImg: '',
            openKm: '',
            closeKmImg: '',
            closeKm: '',
            errorOpenKM: '',
            errorCloseKM: '',
            originCloseImg: '',
            srVehicleNo: '',
            tripTitle: 'Start Trip',
            tripCreatedDate: '',
            currentDateTime: '',
            tripDayflag: 0,
            tripDateFlag: false,
            vehicleTypeFlag: false,
            vehicleNo: '',
            vehicleOpenKM: '',
            errVehicleNo: '',
            vehicleTypeFlag: false,
            vehicleType: '',
            srVehicleList: [],
            vehicleNoItemObj: {
                value: '',
                text: ''
            },
            errVehicleKm: '',
            isVehicleReplacedCheck: 0,
            isVehicleReplaced: false,
            vehicleVendorId: '',
            allocationLoader: false,
            PrintShipmentModal: false,
            batchCreatedDate: '',
            PrintShipmentsList: [],
            PrintShipmentsColumns: [{
                    label: "Delivery User",
                    key: "SrName",
                },
                {
                    label: "Created Date",
                    key: "CreatedDate",
                },
            ],
            ShowPrintTable: false,
            isLoadPDF: false,
            isLoadBatch: false,
            shippingIDArray: [],
            ResCreatedDate: '',
            EnableHyperLink: false,
            unallocatePageNumber: 1,
            unallocatePageLimit: 10,
            unallocateTotalCount: 0,
            unallocatepageCount: 1,
            AccAWBNumbers: '',
            showAllocatedShipmentsList: [],
            srallocatePageNumber: 1,
            srAllocatedTotalCount: 0,
            srAllocatedPageCount: 1,
            srAllocatedPageLimit: 10,
            huballocatePageNumber: 1,
            hubAllocatedTotalCount: 0,
            hubAllocatedPageCount: 0,
            hubAllocatedPageLimit: 10,
            IsAllData: true,
            Tobeattempted: false,
            Pddbreached: false,
            Pddbreachedinnext24hours: false,
            FakeAttempt: false,
            disableprint: false,
            AllCount: 0,
            pddBreachedCount: 0,
            PDDBreachedinNext24hrsCount: 0,
            fakeAttemptsCount: 0,
            tobeAttemptedTodayCount: 0,
            NonAllocationRsn: false,
            Reason: '',
            ReasonList: [],
            ReasonObj: {
                text: ""
            },
            hideAllocateFlag: false,
            TopReset: true,
            AllocateTableLoader: false,
            PDTableLoader: false,
            SMTableLoader: false,
            UATableLoader: false,
            HUbAllocatedTableLoader: false,
            CountLoading: false,
            TitleName: '',
            arrReasonList: [],
            BucketName: '',
            fromList: [{
                value: "UA",
                text: "From Mobile"
            }, {
                value: "Web",
                text: "From Web"
            }],
            fromItemObj: {
                value: "UA",
                text: "From Mobile"
            },
            fromId: "UA",
            vehicleNoRegExp: /^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$/,
            ResetLoader: false,
            resultCount: 0,
            SEQShippingids: [],

            //New Allocation as per mobile
            isShowPendingAllocatedList: true, //Show the pending list
            pendingSrShipmentCount: 0,
            pendingSVCShipmentCount: 0,
            allocateSrShipmentCount: 0,
            allocateSVCShipmentCount: 0,
            setDashboardCountTabNameType: 'pending',
            setCountSR: 0,
            setCountSVC: 0,
            srBlockFlag: false,
            svcBlockFlag: false,

            //Allocated
            setCountSRAllocated: 0,
            setCountSVCAllocated: 0,
            srAllocatedBlockFlag: false,
            svcAllocatedBlockFlag: false,
            // //Counts Pending Sr
            // setSRCountAll: 0,
            // setSRCountP0: 0,
            // setSRCountP1: 0,
            // setSRCountP2: 0,
            // setSRCountSame_route: 0,

            // //Counts Allocated Sr
            // setSRAllocatedCountAll: 0,
            // setSRAllocatedCountP0: 0,
            // setSRAllocatedCountP1: 0,
            // setSRAllocatedCountP2: 0,
            // setSRAllocatedCountSame_route: 0,
            // //Count Pending Hide Show flag for SR
            // setSRCountAllFlag: false,
            // setSRCountP0Flag: false,
            // setSRCountP1Flag: false,
            // setSRCountP2Flag: false,
            // setSRCountSame_routeFlag: false,
            // //Count Allocated Hide Show flag for SR
            // setSRAllocatedCountAllFlag: false,
            // setSRAllocatedCountP0Flag: false,
            // setSRAllocatedCountP1Flag: false,
            // setSRAllocatedCountP2Flag: false,
            // setSRAllocatedCountSame_routeFlag: false,
            // //List Pending Sr
            // setSRListAll: [],
            // setSRListP0: [],
            // setSRListP1: [],
            // setSRListP2: [],
            // setSRListSame_route: [],
            // //List Allocated Sr List
            // setSRAllocatedListAll: [],
            // setSRAllocatedListP0: [],
            // setSRAllocatedListP1: [],
            // setSRAllocatedListP2: [],
            // setSRAllocatedListSame_route: [],
            // //Count Pending SVC
            // setSVCCountAll: 0,
            // setSVCCountP0: 0,
            // setSVCCountP1: 0,
            // setSVCCountP2: 0,
            // setSVCCountSame_route: 0,

            // //Count Allocated SVC
            // setSVCAllocatedCountAll: 0,
            // setSVCAllocatedCountP0: 0,
            // setSVCAllocatedCountP1: 0,
            // setSVCAllocatedCountP2: 0,
            // setSVCAllocatedCountSame_route: 0,

            // //List Pending SVC
            // setSVCListAll: [],
            // setSVCListP0: [],
            // setSVCListP1: [],
            // setSVCListP2: [],
            // setSVCListSame_route: [],
            // //List Allocated SVC
            // setSVCAllocatedListAll: [],
            // setSVCAllocatedListP0: [],
            // setSVCAllocatedListP1: [],
            // setSVCAllocatedListP2: [],
            // setSVCAllocatedListSame_route: [],
            // //Count Pending Hide Show flag for SVC
            // setSVCCountAllFlag: false,
            // setSVCCountP0Flag: false,
            // setSVCCountP1Flag: false,
            // setSVCCountP2Flag: false,
            // setSVCCountSame_routeFlag: false,

            // //Count Allocated Hide Show flag for SVC
            // setSVCAllocatedCountAllFlag: false,
            // setSVCAllocatedCountP0Flag: false,
            // setSVCAllocatedCountP1Flag: false,
            // setSVCAllocatedCountP2Flag: false,
            // setSVCAllocatedCountSame_routeFlag: false,
            //active tab show flag for Pending
            activeTabSR: "light",
            activeTabSVC: 'light',
            //active tab show flag for Allocated
            activeTabSRAllocated: "light",
            activeTabSVCAllocated: 'light',

            //highlight active button flag pending SR
            // activeTabSRAllFlag: 'light',
            // activeTabSRP0Flag: 'light',
            // activeTabSRP1Flag: 'light',
            // activeTabSRP2Flag: 'light',
            // activeTabSRSameRouteFlag: 'light',

            // //highlight active button flag pending SR
            // activeTabSRAllocatedAllFlag: 'light',
            // activeTabSRAllocatedP0Flag: 'light',
            // activeTabSRAllocatedP1Flag: 'light',
            // activeTabSRAllocatedP2Flag: 'light',
            // activeTabSRSameRouteFlag: 'light',


            // //highlight active button flag pending SVC
            // activeTabSVCAllFlag: 'light',
            // activeTabSVCP0Flag: 'light',
            // activeTabSVCP1Flag: 'light',
            // activeTabSVCP2Flag: 'light',
            // activeTabSVCSameRouteFlag: 'light',

            // //highlight active button flag Allocated SVC
            // activeTabSVCAllocatedAllFlag: 'light',
            // activeTabSVCAllocatedP0Flag: 'light',
            // activeTabSVCAllocatedP1Flag: 'light',
            // activeTabSVCAllocatedP2Flag: 'light',
            // activeTabSVCAllocatedSameRouteFlag: 'light',

            //Search
            showUnallocatedListFilter: [],
            showAllocatedShipmentsListFilter: [],

            //non allocation reason
            isCantallocate: false,
            submitreasonbtn: false,
            cantallocatebtn: false,
            cancelResaonBtnText: '',
            buttonVariant: 'success',
            shipmentInfoFlag: false,
            userDataKey: '',
            ActiveTabIndex: 0,
            client: '',
            // hubCODPendingLimit: '',
            // IsPendingCODBlock: false,
            isShowCODAmount: false,
            srCODPendingMsg: '',
            dismissCountDownCOD: 0,
            hvOnboardingFailMsg: '',
            hvSelieFailMsg: '',
            isShowDummyInput: false,
            styleData: {},
            dummyInputTimeout: 20000,

            /* Updated Code here */
            svcPriorities: [], // dynamically filled
            srPriorities: [],

            /* Updated Code here */
            svcAllocatedPriorities: [], // dynamically filled
            srAllocatedPriorities: [],

            /* Refersh Count and list when new shipment allocate */
            refershcountandlist : false,
            clientcheck: false,
            triggeredByDialog : false,
            airshipmentscount:0,
            WHIZshipmentcount:0,
            MOTList : [],
            MOTObj: {
                value: "",
                text: ""
            },
            MOT: '',
            tripProvisionType: null,
            isTripAlreadyStarted: false,
            allocationMsgprexo :{},
        };
    },
    watch: {
        shipmentNo: createClearInputWatcher('shipmentNo'),
        hyperVMsgData: {
            handler() {
                this.setHyperVMsgs();
            },
            deep: true,
        },
    },
    filters: {
        batchCreatedDateFormat: function(date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    created() {
        ensureShipmentInputDetector(this);
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        //this.userDataKey = 'Key';
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.checkRoutingMode();
        this.setHyperVMsgs();
        // await this.GetHubFlags(this.userHubId);
        // this.GetDeliverySRList(this.userHubId);
        this.GetClientList();
        // this.GetServiceTypeList();
        // this.GetClusterIds();
        // this.GetEscalation();
        // this.loadUnallocatedShipmentsList();
        // this.GetCount();
        // this.loadAllocatedShipmentListInHub()
        // this.vehicleNoRegExp = new RegExp('^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$');
    },
    methods: {
        checkRoutingMode() {
            // Fetch the hub's routing mode. When auto routing is enabled we hide
            // the manual SR selection/reset controls and instead surface a button
            // that takes the user to the shipment allocation routing page.
            getHubRoutingMode({ hubId: this.userHubId }, (res) => {
                this.isAutoRoutingMode = !!(res && res.data && res.data.data && res.data.data.isAutoRoutingMode);
            }).catch(() => {
                this.isAutoRoutingMode = false;
            });
        },
        
        goToShipmentAllocationRouting() {
            // vue-router 2.x: push() does not return a promise, so no .catch().
            this.$router.push('/shipmentallocationrouting');
        },

        async selectSR(obj) {      
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.isAllocation = false
            this.hideAllocateFlag = true;
            this.shipmentNo = ''
            this.resetShipmentInputType()
            this.ebnVehicleNo = '',
            this.errEbnVehicleNo = '',
            this.flagShowEbnVehicleNo = false;

            if(!obj || !obj.value){
                return false;
            }

            this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;
            this.OldUserid = obj.OldUserid;
            this.EmpType = obj.EmpType;
            this.CourierCompanyID = obj.CourierCompanyID;
            this.MobileNumber = obj.MobileNumber;
            this.IsSRNeedTrip = obj.IsSRNeedTrip;
            this.vehicleTypeFlag = false;
            this.tripDayflag = 0;
            this.disableprint = true;
            this.isShowCODAmount = false;
            this.srCODPendingMsg = '';

            if(!obj.ishvonboardingdone || !obj.isselfieverified){
                let hyperVFailureMsg = !obj.ishvonboardingdone ? this.hvOnboardingFailMsg : this.hvSelieFailMsg;
                this.hideAllocateFlag = false;
                return this.$alertify.error(hyperVFailureMsg);
            }

            const eodShipValidation = await this.validateEODAllocation();
            if(eodShipValidation || obj.isCodLimitBreached){
                if(obj.isCodLimitBreached && !eodShipValidation){
                    this.isShowCODAmount = true;
                    this.dismissCountDownCOD = this.dismissSecs;
                    this.srCODPendingMsg = `<span style="color: red;"> Pending amount on SR: ${obj.codPendingAmt} <br/> Pending Amount Limit: ${this.hubCODPendingLimit} </span>`
                }
                let alertMsg = eodShipValidation ? eodShipValidation : 'Please clear the pending COD Amount against the user and try again.';
                this.hideAllocateFlag = false;
                return this.$alertify.error(alertMsg);
            }
            else{
                this.CountLoading = true;
                this.allocationDashboardCount();
            }
            if (this.EmpType == null || this.EmpType == "") {
                this.$alertify.error("EmpType not found against this SR, EmpType is required.")
            } else if (this.IsSRNeedTrip == true) {
                this.TopReset = false
                this.IsSRNeedTrip = true
                this.tripDayflag = 0;
                this.SRSelectingloader = true;
                this.vehicleType = ""
                this.srVehicleList = []
                this.vehicleNoItemObj = {
                    value: '',
                    text: ''
                }
                this.vehicleOpenKM = ''
                this.vehicleNo = ''
                this.vehicleVendorId = 0
                this.startAllocationFlag = false
                this.tripTitle = 'Start Trip'
                this.errorCloseKM = ''
                this.errorOpenKM = ''
                this.closeKm = ''
                this.tripState = ''
                this.ValiadteTripdetails();
            }
            this.AllocatedFwdShipmentData();
            this.PreviousDayShipmentList();
            //this.SameRouteShipmentList();
        },
        setHyperVMsgs() {
            const msgData = this.hyperVMsgData || {};
            this.hvOnboardingFailMsg = msgData.hvOnboardingFailMsg || 'SR onboarding is not completed. Please complete the onboarding and try again.';
            this.hvSelieFailMsg = msgData.hvSelieFailMsg || 'SR selfie verification is not completed. Please complete the selfie verification and try again.';
        },
        GetDeliverySRList(hubid) {
            this.srLoader = this.loader;
            this.srArrayList = [];
            this.srList = [];
            let payload = {
                "usertype": "3",
                "hubid": [hubid],
                "isCODApiCall": this.IsPendingCODBlock ? true : false,
            }
            getHubDeliverySRListByHubID(payload, (result) => {
                this.srArrayList = result.data.data.results;
                this.hvOnboardingFailMsg = result.data.data.hvonboardingfailmsg;
                this.hvSelieFailMsg = result.data.data.hvselfiefailmsg;

                for (var i = 0; i < this.srArrayList.length; i++) {
                    const srCODPendingAmt = this.srArrayList[i].codPendingAmount;
                    const isDayAllocationDone = this.srArrayList[i].IsDayAllocationDone;
                    let CodLimitBreachedFlag = !isDayAllocationDone && this.hubCODPendingLimit != null && srCODPendingAmt > 0 && srCODPendingAmt > this.hubCODPendingLimit;
      
                    this.srList.push({
                        value: this.srArrayList[i].userid,
                        text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                        OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
                        EmpType: this.srArrayList[i].EmpType,
                        CourierCompanyID: this.srArrayList[i].CourierCompanyID,
                        MobileNumber: this.srArrayList[i].MobileNumber,
                        IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR,
                        isCodLimitBreached: CodLimitBreachedFlag,
                        codPendingAmt: srCODPendingAmt,
                        isselfieverified: typeof(this.srArrayList[i].isselfieverified) != "undefined" ? this.srArrayList[i].isselfieverified : true,
                        ishvonboardingdone: typeof(this.srArrayList[i].ishvonboardingdone) != "undefined" ? this.srArrayList[i].ishvonboardingdone : true,
                    })
                }
                this.srLoader = '';
            })
        },
        selectFrom(obj) {
            this.fromItemObj = obj
            this.fromId = obj.value
        },
        // GetHubFlags() {
        //     return new Promise((resolve, reject) => {
        //         let HubFlagsPayload = {
        //             "Outsourceid": 4,
        //             "hubid": this.userHubId
        //         }
        //         GetHubFlags2(HubFlagsPayload, (result) => {
        //             if (result.data.data.code == 200) {
        //                 this.isRSVSr = result.data.data.data.IsRSVSr;
        //                 const hubCodLimit = result.data.data.data.configSetting.CODPendingLimit;
        //                 this.hubCODPendingLimit = (hubCodLimit && hubCodLimit != 0) ? hubCodLimit : null;
        //                 this.IsPendingCODBlock = result.data.data.data.configSetting.IsPendingCODBlock;
        //             } else {
        //                 this.$alertify.error(result.data.data.message)
        //             }
        //             resolve(true);
        //         })
        //     })
        // },
        selectClient(obj) {
            this.ClientObj = obj;
            this.Clientname = obj.value
        },
        GetClientList() {
            this.ClientLoader = this.loader;
            let payload = {}
            ClientNameList(payload, (result) => {
                this.clientArrayList = result.data.data ? result.data.data : [];
                if (this.clientArrayList.length > 0) {
                    for (let i = 0; i < this.clientArrayList.length; i++) {
                        this.clientList.push({
                            value: this.clientArrayList[i].ClientMasterID,
                            text: `${this.clientArrayList[i].CompanyName}`
                        })
                    }
                }
               
                this.ClientLoader = '';
            })
        },
        selectServiceType(obj) {
            this.ServiceTypeObj = obj;
            this.ServiceType = obj.text
        },
        // GetServiceTypeList() {
        //     this.ServiceLoader = this.loader;
        //     let payload = {
        //         "serviceTypeValuesRequired": true
        //     }
        //     ServiceType1(payload, (result) => {
        //         this.ServiceTypeArrayList = result.data.data.serviceType;
        //         for (let i = 0; i < this.ServiceTypeArrayList.length; i++) {
        //             this.ServiceTypeList.push({
        //                 text: `${this.ServiceTypeArrayList[i]}`
        //             })
        //         }
        //         this.ServiceLoader = '';
        //     })
        // },
        selectWeightG(obj) {
            this.WeightGObj = obj;
            this.WeightGroup = obj.text
        },
        selectEscalation(obj) {
            this.EscalationObj = obj;
            this.Escalation = obj.text
        },
        // GetEscalation() {
        //     this.EscalationLoader = this.loader;
        //     let payload = {}
        //     GetEscalation(payload, (result) => {
        //         this.EscalationListArrayList = result.data.data;
        //         for (let i = 0; i < this.EscalationListArrayList.length; i++) {
        //             this.EscalationList.push({
        //                 text: `${this.EscalationListArrayList[i]}`
        //             })
        //         }
        //         this.EscalationLoader = '';
        //     })
        // },

        selectCluster(obj) {
            this.ClusterObj = obj;
            this.ClusterId = obj.text
        },
        // GetClusterIds() {
        //     let payload = {
        //         "hubid": this.userHubId,
        //     }
        //     GetClusterIdList(payload, (result) => {
        //         this.ClusterArrayList = result.data.data;
        //         for (let i = 0; i < this.ClusterArrayList.length; i++) {
        //             this.ClusterList.push({
        //                 value: this.ClusterArrayList[i].clusterId,
        //                 text: `${this.ClusterArrayList[i].clusterName}`,
        //             })
        //         }
        //     })
        // },
        async validateEODAllocation() {
            return new Promise((resolve, reject)=>{
                let EODvalidationdata = {
                    "DeliveryUserID": this.SrId,
                    "HubID": this.userHubId
                }
                EODValidation(EODvalidationdata, (result) => {
                    if (result.data.code === 202) {
                        this.hideAllocateFlag = false;
                        this.isShowPendingAllocatedList = false;
                        resolve(result.data.message);
                    } else {
                        this.hideAllocateFlag = true;
                        this.isShowPendingAllocatedList = true;
                        resolve(false);
                    }
                    this.TopReset = false
                        //this.isShowPendingAllocatedList = false;
                })
            })
        },
        ValiadteTripdetails() {
            let TripDetailsPayload = {
                "XBkey": "XB123",
                "HubId": this.userHubId,
                "DeliveryUserId": this.SrId
            }
            GetTripdetails(TripDetailsPayload, (result) => {
                this.tripProvisionType = result.data.tripProvisionType || null;
                this.isTripAlreadyStarted = result.data.isTripAlreadyStarted || false;
    
                if (result.data.TripState == "closed") {
                    this.tripState = 'created'
                    this.startTripFlag = true
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "created" || result.data.TripState == "start") {
                    this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
                    this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
                    if (this.tripCreatedDate == this.currentDateTime) {
                        this.tripDayflag = 0;
                        this.tripDateFlag = false;
                    } else {
                        this.tripDayflag = result.data.tripDayflag
                        this.tripDateFlag = true;
                    }
                    this.startTripFlag = true
                    this.tripState = result.data.TripState
                    this.tripTitle = "Continue trip"
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "deliveryuserclosed" && result.data.code == 200) {
                    this.openKM = result.data.OpenKM
                    this.openKmImg = result.data.OpenKMImageUrl
                    this.closeKmImg = result.data.CloseKMImagUrl
                    this.originCloseImg = result.data.CloseKMImagUrl
                    this.tripId = result.data.TripId
                    this.srVehicleNo = result.data.VehicleNo
                    this.openKm = result.data.OpenKM
                    this.closeTripModel = true
                    this.SRSelectingloader = false;
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                }
            }, error => {
                console.error(error)
            })
        },
        startTrip() {
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            if (this.tripTitle == 'Start Trip') {
                this.vehicleTypeFlag = true
            } else {
                this.startAllocation(false)
            }
        },
        selectVehicleNo(obj) {
            this.vehicleNoItemObj = obj
            this.vehicleNo = obj.text
            this.vehicleVendorId = obj.value
        },
        loadVehicleDetails(type) {
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.startAllocationFlag = false
            this.vehicleType = type
            this.srVehicleList = []
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleOpenKM = ''
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (type == "bike") {
                let payload = {
                    "srid": this.SrId,
                    "hubid": this.userHubId
                }
                BikeVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        var srVehicleList = result.data.data.data
                        for (var i = 0; i < srVehicleList.length; i++) {
                            this.srVehicleList.push({ text: srVehicleList[i].VehicleNumber })
                        }
                    }
                })
            } else if (type == "vehicle") {
                let payload = {
                    "HubId": this.userHubId,
                    "SrUserId": parseInt(this.SrId),
                    "isCrossModuleTripActive": this.isTripAlreadyStarted          
                }
                VehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        if (type == "vehicle") {
                            var srVehicleList = result.data.data.Data
                            for (var i = 0; i < srVehicleList.length; i++) {
                                this.srVehicleList.push({
                                    value: srVehicleList[i].VendorVehicleId,
                                    text: srVehicleList[i].VehicleNumber
                                })
                            }
                        }
                    }
                })
            } else if(type == "adhoc"){
                let payload = {
                    "HubId": this.userHubId,
                    "SrUserId": parseInt(this.SrId),
                    "isCrossModuleTripActive": this.isTripAlreadyStarted          
                }
                AdhocVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        if (type == "adhoc") {
                            var adhocVehicleList = result.data.data.Data;
                            for (var i = 0; i < adhocVehicleList.length; i++) {
                                this.srVehicleList.push({
                                    value: adhocVehicleList[i].VehicleNumber,
                                    text: adhocVehicleList[i].VehicleNumber
                                })
                            }
                        }
                    }
                })
            }
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        startAllocation(flag) {
            this.flagShowPreviousShipment = false
            this.startAllocationFlag = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            var decimal = /^\d+(\d{1,2})?$/;
            if (decimal.test(this.vehicleOpenKM) == false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
                this.errVehicleKm = "Enter Correct KM"
            } else if (this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
            } else if (decimal.test(this.vehicleOpenKM) == false && flag) {
                this.errVehicleKm = "Enter Correct KM"
            } else if (flag && this.vehicleOpenKM > 1000000) {
                this.errVehicleKm = "Open Km should be less than 1000000"
            } else {
                this.startAllocationFlag = true
                if (flag) {
                    this.TripCreation();
                }
            }
            this.isShowPendingAllocatedList = true;
        },
        TripCreation() {
            this.allocationLoader = true;
            let payload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "Delivery",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "operationType": "lastmile"
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                payload['isvehicleupdated'] = true
            } else {
                payload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                payload['vehiclevendorid'] = this.vehicleVendorId
            }
            CreateTrip(payload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "createTrip",
                            "srname": this.SrName,
                            "triptype": "Delivery",
                            "hubid": this.userHubId
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.startAllocationFlag = true;
                    this.$alertify.success(result.data.message);

                } else if (result.data.code == 202) {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                } else {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                }
                this.allocationLoader = false;
            }, error => {
                this.startAllocationFlag = false;
                this.$alertify.error('Failed to Create Trip, Please retry!');
                this.allocationLoader = false;
                console.error(error)
            })
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        loadOpenImageError(imageSrc, type) {
            var srcLink = "static/img/defaultImg.png"
            this.openKmImg = srcLink
        },
        loadCloseImageError(imageSrc) {
            var srcLink = "static/img/defaultImg.png"
            this.originCloseImg = imageSrc
            this.closeKmImg = srcLink
        },
        verifyTrip() {
            if (this.openKm >= 1000000) {
                this.errorOpenKM = "Open Km should be less than 1000000";
            } else {
                this.errorOpenKM = '';
                if (parseFloat(this.closeKm) > parseFloat(this.openKm)) {
                    let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
                    if (calculatekm < 200) {
                        this.errorCloseKM = '';
                        let payload = {
                            "XBkey": "XB123",
                            "tripid": this.tripId,
                            "sruserid": this.SrId.toString(),
                            "hubid": this.userHubId,
                            "km": this.closeKm,
                            "Openkm": this.openKm,
                            "tripstate": "closed",
                            "vehicleno": this.srVehicleNo,
                            "isvehiclereplaced": false,
                            "lastmodifiedby": this.createdBy,
                            "operationType": "lastmile"
                        }
                        CloseTrip(payload, (result) => {
                            if (result.data.code == 200) {
                                let TrackerInfo = {
                                    projectname: "Last Mile",
                                    type: "Web",
                                    userid: this.userid,
                                    username: this.createdBy,
                                    meta: {
                                        "event": "closeTrip",
                                        "tripid": this.tripId,
                                        "sruserid": this.SrId.toString()
                                    }
                                }
                                this.PageTracker(TrackerInfo);
                                this.$alertify.success(result.data.message)
                                    //   this.resetTrip()
                                this.closeTripModel = false
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        })
                    } else {
                        this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
                    }
                } else {
                    this.errorCloseKM = "Close KM should be greater then open KM"
                }
            }
        },
        closeCloseTripModel() {
            this.closeTripModel = false
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChangedCOD(dismissCountDownCOD){
            this.dismissCountDownCOD = dismissCountDownCOD
        },
        countDownChangedSuccess(dismissCountDownSuccess) {
            this.dismissCountDownSuccess = dismissCountDownSuccess
        },
        loadAllocatedDetails() {
            this.AllocatedFwdShipmentData();
        },
        isManualShipmentInputBlocked() {
            return this.isScannerOnlyAllocationEnabled && this.shipmentInputType === INPUT_TYPE.MANUAL;
        },
        clearShipmentNoInput() {
            this.shipmentNo = '';
            const input = this.$refs.shipmentNo;
            if (input) {
                input.value = '';
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        },
        handleManualShipmentInputBlocked() {
            const errorMsg = 'Manual entry is not allowed — please scan the Shipment No.';
            this.$alertify.error(errorMsg);
            this.AllocateLoading = false;
            this._shipmentManualBlocked = true;
            this.shipmentInputType = INPUT_TYPE.MANUAL;
            this.resetShipmentInputType();
            this.clearShipmentNoInput();
            this.$nextTick(() => {
                this.clearShipmentNoInput();
                if (this.$refs.shipmentNo) {
                    this.$refs.shipmentNo.focus();
                }
                window.setTimeout(() => {
                    this.clearShipmentNoInput();
                    this._shipmentManualBlocked = false;
                }, 250);
            });
        },
        handleShipmentNoKeyDown(event) {
            const keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode === 13) {
                event.preventDefault();
                return;
            }
            if (!this.isScannerOnlyAllocationEnabled) {
                return;
            }
            if (keycode === 9) {
                return;
            }

            const now = Date.now();
            if (!this.shipmentNo || String(this.shipmentNo).length === 0) {
                this._lastShipmentKeyTime = now;
                return;
            }

            if (this._lastShipmentKeyTime !== null) {
                const timeDiff = now - this._lastShipmentKeyTime;
                if (timeDiff > this.shipmentManualKeyThresholdMs) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.shipmentInputType = INPUT_TYPE.MANUAL;
                    this.$nextTick(() => {
                        this.handleManualShipmentInputBlocked();
                    });
                    return;
                }
            }
            this._lastShipmentKeyTime = now;
        },
        Allocate() {
            if (!this.shipmentInputType) {
                this.shipmentInputType = this.getShipmentInputType();
            }
            if (this.isManualShipmentInputBlocked()) {
                this.handleManualShipmentInputBlocked();
                return;
            }
            if (!this.triggeredByDialog) {
                this.clientcheck = false;
            }
            this.triggeredByDialog = false;
            this.isShowDummyInput = false;
            if (this.flagShowEbnVehicleNo == true) {
                if (this.vehicleNoRegExp.test(this.ebnVehicleNo.toUpperCase()) == false) {
                    return this.errEbnVehicleNo = 'Enter Correct Vehicle No';
                } else {
                    this.errEbnVehicleNo = ''
                }
            }
            var tempStr = this.shipmentNo;
            this.AllocateLoading = true;
            let AllocatePayload = {
                "isAllocationFrom": 'New',
                "XBkey": "XB123",
                "HubId": this.userHubId.toString(),
                "DeliveryUserId": this.SrId,
                "OldDeliveryUserOrUserId": this.OldUserid.toString(),
                "DeliveryUserName": this.SrName,
                "ShippingID": (this.shipmentNo).trim(),
                "LastModifiedBy": this.createdBy,
                "IsConfirmAllocation": false,
                "AllocationType": "Delivery",
                "EmpType": this.EmpType ? this.EmpType : "",
                "MarkedFrom": "Web",
                "CourierCompanyID": this.CourierCompanyID ? this.CourierCompanyID.toString() : 'null',
                "IsRSVCSr": this.isRSVSr,
                "MobileNo": this.MobileNumber ? this.MobileNumber.toString() : "",
                "isTripAllowedForSR": this.IsSRNeedTrip,
                "vehicleno": this.ebnVehicleNo,
                "isImageCaptured": false,
                "shipmentInputType": this.shipmentInputType
            }
            
            if (this.clientcheck) {
                AllocatePayload.isSelfVendorPickup = true;
            }
            
            AllocateShipment(AllocatePayload, (result) => {
                this.isShowDummyInput = true;
                this.styleData = result.data.lossCategorization;
                if (result.data.code == 200) {
                    //Handle Prexo shipment Success
                    this.allocationMsgprexo  = result.data.prexoShipment ? ('This is PREXO shipment and its related RVP shipment is :-'+ result.data.prexoShipment): null;
                    this.refershcountandlist = true;
                    setTimeout(() => {
                        if (this.refershcountandlist) {
                            this.allocationDashboardCount();
                        }
                    }, this.allocationrefreshflag);
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            routeurl: "expose/shipment/allocate",
                            meta: {
                                event: "shipmentAllocation",
                                shipmentId: this.shipmentNo ? this.shipmentNo : null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, AllocatePayload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                    this.isAllocation = true;
                    // this.AllocatedFwdShipmentData();
                    // this.loadAllocatedShipmentListInHub();
                    // this.loadUnallocatedShipmentsList();
                    // this.GetCount();
                    this.shipmentNo = '';
                    this.resetShipmentInputType();
                    this.$refs.shipmentNo.focus();
                    this.dismissCountDownSuccess = 20;
                    this.allocationSuccessMsg = tempStr + " :- " + result.data.message;
                    this.flagShowEbnVehicleNo = false;
                    this.ebnVehicleNo = '';
                    this.errEbnVehicleNo = '';
                    // this.ebnVehicleNo = '';
                    if (typeof result.data.status != undefined && result.data.status == 206 && result.data.data.length > 1) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.mpsErrormsg;
                        let pendingMPSData = result.data.data
                        this.showParentGroupIdShipmentList = pendingMPSData.filter(obj => obj != tempStr);
                    }

                    // Refresh Count - Pending and Allocated Shipment
                    // this.allocationDashboardCount();
                    this.loadAllocatedDetails('reload')

                } else {                    
                    if(result.data.status  && result.data.status==210){
                       this.selfPickupClientDialog();
                       this.AllocateLoading = false;
                       return false;
                    }
                    if (typeof result.data.status != undefined && result.data.status == 204) {
                        this.flagShowPreviousShipment = true
                    }
                    if (typeof result.data.status != undefined && result.data.status == 207) {
                        this.flagShowEbnVehicleNo = true;
                        this.shipmentNo = tempStr;
                        this.$refs.ebnVehicleNo.focus();
                    }

                    if (typeof result.data.status != undefined && result.data.status == 209) {
                        this.ReAttemptLongPincodeAllocation(result);
                    }
                    this.$refs.shipmentNo.focus();
                    this.dismissCountDown = 20
                    this.allocationErrorMsg = result.data.message != '' && result.data.message != undefined ? `${tempStr} :-  ${result.data.message}` : `${tempStr} :- Not getting any response message.`
                    //Handle Prexo shipment error
                    this.allocationMsgprexo  = result.data.prexoShipment ? ('This is a PREXO shipment, and its associated RVP shipment is :-'+ result.data.prexoShipment): null;
                }
                this.AllocateLoading = false;
            })
        },
        selectReason(obj) {
            this.ReasonObj = obj;
            this.Reason = obj.text
        },
        CheckPDD() {
            this.CloseNonAllocationRsn()
            let Payload = {
                "srId": this.SrId,
                "hubId": this.userHubId.toString(),
                "shipmentType": "Delivery",
                "type": "Pending",
                "requestedBy":this.createdBy
            }
            GetNonAllocationSEQMobile(Payload, (result) => {
                if (result.data.code == 200 && result.data.data.length > 0) {
                    this.SeqArray = result.data.data.filter(x => (x.lebal != ""))
                    this.BucketName = this.SeqArray[0].lebal
                    this.TitleName = this.SeqArray[0].lebal
                    this.SEQShippingids = this.SeqArray[0].shipments;
                    this.resultCount = this.SeqArray[0].shipments.length;
                    for (let i = 0; i < this.SeqArray[0].nonAllocationReason.length; i++) {
                        this.ReasonList.push({
                            value: this.SeqArray[0].nonAllocationReason[i].id,
                            text: `${this.SeqArray[0].nonAllocationReason[i].title}`
                        })
                    }
                    this.cancelResaonBtnText = 'I will Allocate';
                    this.cantallocatebtn = true;
                    this.NonAllocationRsn = true;
                    this.buttonVariant = 'success';
                } else {
                    this.confirmTrip();
                    this.CloseNonAllocationRsn()
                }
            })
        },
        StoreNonAllocationSeq() {
            this.CloseNonAllocationRsn();
            this.TitleName = this.SeqArray[0].lebal
            this.BucketName = this.SeqArray[0].lebal
            this.resultCount = this.SeqArray[0].shipments.length
            this.SEQShippingids = this.SeqArray[0].shipments
            for (let i = 0; i < this.SeqArray[0].nonAllocationReason.length; i++) {
                this.ReasonList.push({
                    value: this.SeqArray[0].nonAllocationReason[i].id,
                    text: `${this.SeqArray[0].nonAllocationReason[i].title}`
                })
            }
            this.cancelResaonBtnText = 'I will Allocate';
            this.cantallocatebtn = true;
            this.NonAllocationRsn = true;
            this.buttonVariant = 'success';
        },
        CloseNonAllocationRsn() {
            this.BucketName = ''
            this.TitleName = ''
            this.Reason = ''
            this.ReasonObj = {
                text: ""
            }
            this.resultCount = 0,
                this.SEQShippingids = []
            this.ReasonList = []
            this.cantallocatebtn = false
            this.submitreasonbtn = false
            this.NonAllocationRsn = false
            this.cancelResaonBtnText = ''
            this.isCantallocate = false
        },
        SubmitNonAllocationRsn() {
            let Payload = {
                "srId": this.SrId,
                "hubId": this.userHubId,
                "createdBy": this.createdBy,
                "data": [{ 'lebal': this.TitleName, 'shipments': this.SEQShippingids, "reasonCode": this.ReasonObj.value.toString(), "reasonText": this.ReasonObj.text }],
                "requestFrom":"WEB"
            }
            StoreReasonMobile(Payload, (result) => {
                if (result.data.code == 200) {
                    this.$alertify.success("Reason Submitted Successfully!!")
                    this.CloseNonAllocationRsn();
                    this.SeqArray.splice(0, 1)
                    if (this.SeqArray.length > 0) {
                        this.StoreNonAllocationSeq();
                    } else {
                        this.confirmTrip();
                    }
                } else if (result.data.code == 204) {
                    this.$alertify.error('Reason is required.')
                }
            })
        },
        async confirmTrip() {
            this.allocationSuccessMsg = ''
            this.isConfirmLoad = true;
            this.showParentGroupIdShipmentList = [];
            let payload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "Delivery",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "LastModifiedBy": this.createdBy,
                "MarkedFrom": this.fromId,
                "operationType": "lastmile",
                "isHandoverDeliveryUser": 1,
                "allocationType":"Delivery"
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                payload['isvehicleupdated'] = true
            } else {
                payload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                payload['vehiclevendorid'] = this.vehicleVendorId
            }
            ConfirmShipment(payload, (result) => {
                if (result.data.code == 200) {
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            routeurl: "expose/shipment/confirm",
                            meta: {
                                event: "expose-shipment-confirm",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, payload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                    this.isAllocation = false
                    this.$alertify.success(result.data.message)
                    this.AllocatedFwdShipmentData();
                    this.allocationDashboardCount();
                    // this.loadAllocatedShipmentListInHub();
                    this.fromId = "UA";
                    // this.resetTrip()
                } else {
                    if (result.data.status == 208) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.message;
                        this.showParentGroupIdShipmentList = result.data.data;
                    } else {
                        this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                    }
                }
                this.isConfirmLoad = false;
            }, error => {
                console.error(error)
                this.isConfirmLoad = false;
            })
        },
        ReAttemptLongPincodeAllocation() {
            let message = {
                title: '',
                body: `<p><b>This shipment belongs to Long Pincode. Do you want to allocate it?</b></p>  <p style="color:green">Click <b> YES</b> to Attempt Delivery. <br/> <span style="color:red"> Press <b> No </b> to Hold the Shipment.</span> </p>`,
            };
            let res = this.$dialog.confirm(message, {
                    html: true,
                    animation: 'bounce',
                    backdropClose: false,
                    okText: 'Yes',
                    cancelText: 'No',
                    reverse: true
                })
                .then(dialog => {
                    this.IsLongPinCodeFlag = true;
                    this.Allocate();
                })
                .catch((e) => {
                    this.IsLongPinCodeFlag = false;
                    this.Allocate();
                })
        },
        ShowPendingShipments() {
            this.showShipmentModel = true
            this.isPodsLoader = true;
            this.PendingList = []
            let PendingPayload = {
                "DeliveryUserId": this.SrId
            }
            PendingList2(PendingPayload, (result) => {
                if (result.data.code == 200) {
                    this.PendingList = result.data.data
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
                this.isPodsLoader = false;
            })
        },
        srAllocatedPagination(pageNum) {
            this.srallocatePageNumber = pageNum;
            this.AllocatedFwdShipmentData();
        },
        AllocatedFwdShipmentData() {
            this.isAllocation = false
            this.AllocateTableLoader = true
            this.AllocatedList = []
            this.srAllocatedTotalCount = 0
            let AllocatedShipmentPayload = {
                "HubId": (this.userHubId).toString(),
                "ShipmentType": 'Delivery',
                "DeliveryUserId": this.SrId,
                "pageNumber": this.srallocatePageNumber,
                "pageLimit": this.srAllocatedPageLimit
            }
            AllocatedFwdShipmentDetails(AllocatedShipmentPayload, (result) => {

                if (result.status == 200 && result.data.code == 200) {
                    this.AllocatedList = result.data.data.rows
                    if (this.AllocatedList.length > 0) {
                        this.isAllocation = true
                    }
                    this.srAllocatedTotalCount = result.data.data.count;

                    if (this.srAllocatedTotalCount < this.srAllocatedPageLimit) {
                        this.srAllocatedPageCount = 1
                    } else {
                        this.srAllocatedPageCount = Math.ceil(this.srAllocatedTotalCount / this.srAllocatedPageLimit);
                    }
                    this.AllocateTableLoader = false
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            userid: this.userid,
                            username: this.createdBy,
                            routeurl:
                                "/exposeallocationapis/get/allocated/shipments/List",
                            meta: {
                                event: "get-allocated-shipments-List",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, AllocatedShipmentPayload);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else if (result.status == 200 && result.data.code != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                } else if (result.status != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                }
            })
        },
        // loadAllocatedShipmentListInHub() {
        //     this.HUbAllocatedTableLoader = true
        //     this.showAllocatedShipmentsList = []
        //     this.hubAllocatedTotalCount = 0
        //     let reqAllocatePayload = {
        //         "HubId": (this.userHubId).toString(),
        //         "ShipmentType": 'Delivery',
        //         "pageNumber": this.huballocatePageNumber,
        //         "pageLimit": this.hubAllocatedPageLimit
        //     }

        //     AllocatedFwdShipmentDetails(reqAllocatePayload, (result) => {
        //         if (result.status == 200 && result.data.code == 200) {
        //             this.showAllocatedShipmentsList = result.data.data.rows
        //             this.hubAllocatedTotalCount = result.data.data.count;

        //             if (this.hubAllocatedTotalCount < this.hubAllocatedPageLimit) {
        //                 this.hubAllocatedPageCount = 1
        //             } else {
        //                 this.hubAllocatedPageCount = Math.ceil(this.hubAllocatedTotalCount / this.hubAllocatedPageLimit);
        //             }
        //             this.HUbAllocatedTableLoader = false
        //         } else if (result.status == 200 && result.data.code != 200) {
        //             this.hubAllocatedTotalCount = 0
        //             this.hubAllocatedPageCount = 1
        //             this.HUbAllocatedTableLoader = false
        //         } else if (result.status != 200) {
        //             this.hubAllocatedTotalCount = 0
        //             this.hubAllocatedPageCount = 1
        //             this.HUbAllocatedTableLoader = false
        //         }
        //     })
        // },
        // hubAllocatedPagination(pageNum) {
        //     this.huballocatePageNumber = pageNum;
        //     this.loadAllocatedShipmentListInHub();
        // },
        RemoveShipment(shippingId) {
            let Payload = {
                XBkey: "XB123",
                ShippingID: shippingId,
                LastModifiedBy: this.createdBy,
            }
            RemoveAllocatedShipment(Payload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "RemoveShipment",
                            "ShippingID": shippingId.toString()
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.AllocatedFwdShipmentData()
                    this.allocationDashboardCount();
                    // this.loadAllocatedShipmentListInHub();
                    // this.loadUnallocatedShipmentsList();
                    this.$alertify.success("Shipment Successfully Removed")
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
            }, error => {
                console.error(error)
            })
        },

        PreviousDayShipmentList() {
            this.PDTableLoader = true;
            this.SuggestionList = [];
            if (this.SrId == '') {
                this.PDTableLoader = false;
            }
            let PreviousDayPayload = {
                "HubId": this.userHubId.toString(),
                "DeliveryUserId": this.SrId,
                "shipmenttype": "Delivery",
            }
            PreviousDayShipmentDetails(PreviousDayPayload, (result) => {
                this.SuggestionList = result.data.data;
                this.PDTableLoader = false;
            })
            this.PDTableLoader = false;
        },
        SameRouteShipmentList() {
            this.SMTableLoader = true
            this.SameRouteList = [];
            if (this.SrId == '') {
                this.SMTableLoader = false;
            }
            let SameRoutePayload = {
                "DeliveryUserId": this.SrId,
                "HubId": (this.userHubId).toString(),
                "shipmenttype": "Delivery",
            }
            SameRouteShipments(SameRoutePayload, (result) => {
                this.SameRouteList = result.data.data;
                this.SMTableLoader = false;
            })
            this.SMTableLoader = false;
        },

        PendingAllocationShipmentList() {
            let pendingShipmentPayload = {
                "HubID": this.userHubId,
                "ShipmentType": "Forward",
                "PageNo": 1
            }
            pendingshipmentList(pendingShipmentPayload, (result) => {
                console.log('GET PENDING SHIPMENT LIST ---->>', result);
            })
        },
        HandleDragOver(event) {
            event.preventDefault();
        },
        resolveShipmentInputType(keycode, keyFiredCount, inputValue) {
            return resolveShipmentInputType({ keycode, keyFiredCount, inputValue });
        },
        resetShipmentInputType() {
            ensureShipmentInputDetector(this).reset();
            this.shipmentInputType = null;
            this._lastShipmentKeyTime = null;
        },
        ensureShipmentInputDetector() {
            return ensureShipmentInputDetector(this);
        },
        handleShipmentNoKeyUp(event) {
            const detector = this.ensureShipmentInputDetector();
            if (!this._debouncedShipmentNoKeyUp) {
                this._debouncedShipmentNoKeyUp = detector.createDebouncedKeyUpHandler((e) => {
                    this.onShipmentNoKeyUpDebounced(e);
                });
            }
            this._debouncedShipmentNoKeyUp(event);
        },
        onShipmentNoKeyUpDebounced(event) {
            if (this._shipmentManualBlocked) {
                return;
            }
            const keycode = event.keyCode ? event.keyCode : event.which;
            const inputType = this.ensureShipmentInputDetector().detectInputType(keycode, this.shipmentNo);
            if (inputType) {
                this.shipmentInputType = inputType;
            }
            if (this.isManualShipmentInputBlocked()) {
                this.handleManualShipmentInputBlocked();
                return;
            }
            if (keycode === 13) {
                this._lastShipmentKeyTime = null;
                this.Allocate();
            }
        },
        getShipmentInputType() {
            return this.shipmentInputType || this.ensureShipmentInputDetector().getInputType();
        },
        OnlyNumber: function($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
                $event.preventDefault();
            }
        },
        OpenPrintShipmentModal() {
            this.PrintShipmentModal = true
            this.EnableHyperLink = false
        },
        closePrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentModal = false,
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        ResetPrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentsList = [],
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        GetShipmentPrintdetails() {
            this.PrintShipmentDetails();
            this.ShowPrintTable = true
        },
        PrintShipmentDetails() {
            this.PrintShipmentsList = [];
            this.isLoadBatch = true;
            let batchCdate = moment(this.batchCreatedDate).format('YYYY-MM-DD');
            this.today = new Date();
            let Today = moment(this.today).format('YYYY-MM-DD');
            if (batchCdate == Today) {
                this.EnableHyperLink = true;
            }
            let batchpayload = {
                "UserHubID": this.userHubId.toString(),
                "DeliveryUserID": this.SrId,
                "shipmentType": "Delivery",
                "createdDate": batchCdate
            }
            ShipmentPrintDetails(batchpayload, (result) => {
                if (result.data.code == 200) {
                    this.isLoadBatch = false
                    for (var i = 0; i < result.data.PrintBatchId.length; i++) {
                        this.shippingIDArray = []
                        for (var j = 0; j < result.data.PrintBatchId[i].NoOfShipments; j++) {
                            this.shippingIDArray.push({
                                shippingIDArray: result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                            })
                            this.ResCreatedDate = moment(result.data.PrintBatchId[i].ShippingIDs[j].CreatedDate).format('DD-MM-YYYY')
                        }
                        this.PrintShipmentsList.push({
                            AssignBatchNo: result.data.PrintBatchId[i].AssignBatchNo,
                            NoOfShipments: result.data.PrintBatchId[i].NoOfShipments,
                            shippingIDArray: this.shippingIDArray,
                            SrName: this.SrName,
                            CreatedDate: this.ResCreatedDate
                        })
                    }
                } else {
                    this.isLoadBatch = false
                    this.$alertify.error(result.data.message)
                }
            }, error => {
                console.error(error)
            })
        },
        exportCSVOfShippingIDS(result) {
            let csvContent = "data:text/csv;charset=utf-8,";
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            var today = dd + "" + mm + "" + yyyy;
            let filename = "ShippingID" + today + ".csv";
            csvContent += ['ShippingID',
                    ...result.map(item => Object.values(item).join(";"))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", filename);
            link.click();
        },

        PrintShipment(AssignBatchNo) {
            this.isLoadPDF = true
            this.input = {
                "DeliveryUserID": this.SrId,
                "ShipmentType": "Delivery",
                "BatchId": AssignBatchNo,
                "PrintType": "Delivery",
                "UserName": this.createdBy,
                "PrintFrom": 'FromWeb'
            }
            pdfData(this.input, (result) => {
                if (result.status == 200) {
                    const downloadUrl = window.URL.createObjectURL(new Blob([result.data], {
                        type: 'application/pdf'
                    }))
                    let message = {
                        title: '',
                        body: `<p>Pdf is generated, Would you like to open.!</p>`,
                    };

                    let res = this.$dialog.alert(message, {
                            html: true,
                            animation: 'bounce',
                            backdropClose: false,
                            loader: true
                        })
                        .then(dialog => {
                            window.open(downloadUrl);
                            this.isLoadPDF = false
                            dialog.close();
                        })
                        .catch(() => {
                            this.isLoadPDF = false
                        })
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "expose/web/get/shipmentbysrid",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "expose-web-get-shipmentbysrid",
                                shipmentId: null,
                                hubId: this.userHubId ? this.userHubId : null,
                                remarks: "FrontEnd"
                            },
                        };
                        Object.assign(TrackerInfo.meta, this.input);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    this.isLoadPDF = false;
                    this.$alertify.error('Unable to load pdf, Please try after sometime.!');
                }
            }, error => {
                this.isLoadPDF = false;
                console.error(error)
            })
        },
        // GetCount() {
        //     this.CountLoading = true
        //     let RVPPayload = {
        //         "shipmenttype": "Delivery",
        //         "hubid": this.userHubId.toString()
        //     }
        //     GetShipmentCount(RVPPayload, (result) => {
        //         let CountARR = [];
        //         if (result.data.code == 200) {
        //             CountARR = result.data.data[0]
        //             this.AllCount = CountARR.all
        //             this.tobeAttemptedTodayCount = CountARR.tobeAttemptedToday
        //             this.pddBreachedCount = CountARR.pddBreached
        //             this.PDDBreachedinNext24hrsCount = CountARR.PDDBreachedinNext24hrs
        //             this.fakeAttemptsCount = CountARR.fakeAttempts
        //             this.CountLoading = false
        //         } else {
        //             this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
        //             this.CountLoading = false
        //         }
        //     })
        // },
        Reset() {
            this.allocationSuccessMsg = ''
            this.dismissCountDown = 0,
                this.allocationErrorMsg = "",
                this.dismissCountDownSuccess = 0,
                this.srAllocatedTotalCount = 0
            this.TopReset = true,
                this.fromId = "UA",
                this.hideAllocateFlag = false;
            this.currentScreenTab = 'ALL',
                this.shipmentNo = ''
            this.resetShipmentInputType()
            this.ebnVehicleNo = '',
                this.errEbnVehicleNo = '',
                this.flagShowEbnVehicleNo = false,
                this.SuggestionList = [],
                this.SameRouteList = [],
                this.AllocatedList = [],
                this.disableprint = false
            this.SrId = ''
            this.SrName = ''
            this.srItemObj = {
                value: "",
                text: ""
            }
            this.AllocateTableLoader = false,
                this.AllocateTableLoader = false,
                this.PDTableLoader = false,
                this.SMTableLoader = false,
                this.currentDateTime = '',
                this.tripDayflag = '',
                this.tripCreatedDate = '',
                this.tripDateFlag = false,
                this.IsSRNeedTrip = false
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.tripTitle = 'Start Trip'
            this.isRSVSr = 0
            this.startTripFlag = false
            this.vehicleTypeFlag = false
            this.vehicleType = ""
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            this.vehicleOpenKM = ''
            this.startAllocationFlag = false
            this.isAllocation = false
            this.tripId = ''
            this.openKm = ''
            this.openKmImg = ''
            this.closeKm = ''
            this.closeKmImg = ''
            this.originCloseImg = ''
            this.srVehicleNo = ''
            this.errorCloseKM = ''
            this.errorOpenKM = ''
            this.flagShowPreviousShipment = false
            this.NonAllocationRsn = false
            this.ReasonObj = {
                text: ""
            }
            this.Reason = '',
            this.isShowCODAmount = false;
            this.srCODPendingMsg = '';
            this.isShowDummyInput = false;
            this.$refs.dummyShipInputBox.clearStyles();
            this.$refs.dummyShipInputBox2.clearStyles();
            this.clientcheck = false,
            this.triggeredByDialog = false
            return true;
        },
        RightTabReset(params = null) {
            this.ResetLoader = true
            this.currentScreenTab = 'ALL',
                this.IsAllData = true;
            this.HUbAllocatedTableLoader = false,
                this.IsAllData = true,
                this.Tobeattempted = false,
                this.Pddbreached = false,
                this.Pddbreachedinnext24hours = false,
                this.FakeAttempt = false
            this.Clientname = ''
            this.client = ''
            this.ClientObj = {}
            this.ServiceType = ''
            this.ServiceTypeObj = {
                value: "",
                text: ""
            }
            this.ClusterId = '',
                this.ClusterObj = {
                    value: "",
                    text: ""
                },
                this.WeightGroup = ''
            this.WeightGObj = {}
            this.Escalation = '',
                this.EscalationObj = {
                    value: "",
                    text: ""
                }
            this.AccAWBNumbers = ""
                // this.loadUnallocatedShipmentsList();
            if (params == null) {
                this.showUnallocatedList = this.showUnallocatedListFilter;
            }
            // this.allocationPendingShipmentList();
            this.isShowDummyInput = false;
            this.$refs.dummyShipInputBox.clearStyles();
            this.$refs.dummyShipInputBox2.clearStyles();
            this.ResetLoader = false;
            this.MOT = '';
            this.MOTObj = {
                text : ''
            };

        },
        // unallocatedgetPaginationData(pageNum) {
        //     this.unallocatePageNumber = pageNum;
        //     this.loadUnallocatedShipmentsList();
        // },
        // async GetCurrentScreenValue(currentVal) {
        //     this.unallocatePageNumber = 1
        //     this.$refs.UnAllocatePaginate.selected= 0;
        //     this.currentScreenTab = currentVal;
        //     if (this.currentScreenTab == 'PDDBreached') {
        //         this.Pddbreached = true;
        //         this.IsAllData = false;
        //         this.Tobeattempted = false;
        //         this.Pddbreachedinnext24hours = false;
        //         this.FakeAttempt = false;
        //     } else if (this.currentScreenTab == 'TobeAttemptedToday') {
        //         this.Tobeattempted = true;
        //         this.IsAllData = false;
        //         this.Pddbreached = false;
        //         this.Pddbreachedinnext24hours = false;
        //         this.FakeAttempt = false;
        //     } else if (this.currentScreenTab == 'PDDBreachedinNext24hrs') {
        //         this.IsAllData = false;
        //         this.Tobeattempted = false;
        //         this.Pddbreached = false;
        //         this.Pddbreachedinnext24hours = true;
        //         this.FakeAttempt = false;
        //     } else if (this.currentScreenTab == 'FakeAttempts') {
        //         this.FakeAttempt = true;
        //         this.IsAllData = false;
        //         this.Tobeattempted = false;
        //         this.Pddbreached = false;
        //         this.Pddbreachedinnext24hours = false;
        //     } else {
        //         this.IsAllData = true;
        //         this.Tobeattempted = false;
        //         this.Pddbreached = false;
        //         this.Pddbreachedinnext24hours = false;
        //     }
        //     this.loadUnallocatedShipmentsList();
        // },

        // loadUnallocatedShipmentsList() {
        //     let reqPayload = {
        //         "shipmenttype": "Delivery",
        //         "hubid": this.userHubId,
        //         "pagenumber": this.unallocatePageNumber,
        //         "pagelimit": this.unallocatePageLimit,
        //         "isAllData": this.IsAllData,
        //         "tobeattempted": this.Tobeattempted,
        //         "pddbreached": this.Pddbreached,
        //         "pddbreachedinnext24hours": this.Pddbreachedinnext24hours
        //     }
        //     if (this.AccAWBNumbers != "") {
        //         let shipingID = this.AccAWBNumbers.split(/[\s,]+/);
        //         let shipmentArray = [];
        //         $.each(shipingID, (key, AccAWBNumbers) => {
        //             if (AccAWBNumbers != '') {
        //                 shipmentArray.push(AccAWBNumbers.trim())
        //             }
        //         })
        //         reqPayload.shipmentid = shipmentArray;
        //     }
        //     if (this.Clientname) {
        //         reqPayload.clientid = this.Clientname
        //     }
        //     if (this.ServiceType) {
        //         reqPayload.servicetype = this.ServiceType
        //     }
        //     if (this.WeightGroup) {
        //         reqPayload.weightgroupid = this.WeightGroup
        //     }
        //     if (this.ClusterId) {
        //         reqPayload.clusterid = this.ClusterId
        //     }
        //     if (this.Escalation) {
        //         reqPayload.escalation = this.Escalation
        //     }
        //     this.getPendingShipmentforAllocation(reqPayload)
        // },
        // getPendingShipmentforAllocation(payloadobj) {
        //     this.UATableLoader = true
        //     this.showUnallocatedList = [];
        //     this.unallocateTotalCount = [];
        //     getUnallocatedShipments(payloadobj, (result) => {
        //         if (result.status == 200 && result.data.code == 200) {
        //             this.showUnallocatedList = result.data.data
        //             this.unallocateTotalCount = result.data.totalCount;

        //             if (this.unallocateTotalCount < this.unallocatePageLimit) {
        //                 this.unallocatepageCount = 1
        //             } else {
        //                 this.unallocatepageCount = Math.ceil(this.unallocateTotalCount / this.unallocatePageLimit);
        //             }
        //             this.UATableLoader = false
        //         } else if (result.status == 200 && result.data.code != 200) {
        //             console.log('No Shipments found..');
        //             this.unallocatepageCount = 1
        //             this.UATableLoader = false
        //         } else if (result.status != 200) {
        //             console.log('Something Went wrong with network.!!');
        //             this.unallocatepageCount = 1
        //             this.UATableLoader = false
        //         }
        //     })
        // },

        // New Mobile Allocation :- This api use for Get Pending shipmet count of SR / SVC
        allocationDashboardCount() {
            this.refershcountandlist = false;
            let payloadobj = {
                "srId": this.SrId,
                "hubId": this.userHubId,
                "shipmentType": "Delivery",
            }

            getallocationDashboardCount(payloadobj, (result) => {
                if (result.data.code == 200) {
                    this.pendingSrShipmentCount = result.data.data.pendingCounts.srCount;
                    this.pendingSVCShipmentCount = result.data.data.pendingCounts.svcCount;
                    this.allocateSrShipmentCount = result.data.data.allocatedCounts.srCount;
                    this.allocateSVCShipmentCount = result.data.data.allocatedCounts.svcCount;
                    this.UATableLoader = false
                    this.allocationPendingShipmentList();
                } else if (result.data.code != 200) {
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }
            })
        },

        /* New Mobile Allocaton :- This function used for set the tab name */
        setDashboardCountTabName() {
            this.RightTabReset('dashboardcount');
            this.showUnallocatedList = [];
            this.showAllocatedShipmentsList = [];
            let params = this.ActiveTabIndex == 0 ? 'pending' : 'allocated';
            this.CountLoading = true;
            this.setDashboardCountTabNameType = params;
            this.allocationPendingShipmentList();
        },
        changeSelected(params, subparams) {
            this.showUnallocatedList = [];
            this.showAllocatedShipmentsList = [];
            let upperType = params === 'pendingsr' ? 'SR' : 'SVC';
            if (params == 'pendingsr') {
                this.srBlockFlag = true;
                this.svcBlockFlag = false;
                this.activeTabSR = 'primary';
                this.activeTabSVC = 'light';


                // ---- Show/Hide SR Count Flags ----
                this.srPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.srPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }

                //Show hide flag
                // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;
                // this.setSRCountSame_routeFlag = (this.setSRCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SR
                // if (subparams == 'All') {
                //     this.activeTabSRAllFlag = (subparams == 'All') ? 'primary' : 'light';
                //     this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSRP0Flag = (subparams == 'P0') ? 'primary' : 'light';
                //     this.activeTabSRAllFlag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSRP1Flag = (subparams == 'P1') ? 'primary' : 'light';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP2Flag = this.activeTabSRSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSRP2Flag = (subparams == 'P2') ? 'primary' : 'light';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP2);
                // } else if (subparams == 'SameRoute') {
                //     this.activeTabSRSameRouteFlag = (subparams == 'SameRoute') ? 'primary' : 'light';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListSame_route);
                // }
            } else if (params == 'pendingsvc') {
                this.srBlockFlag = false;
                this.svcBlockFlag = true;
                this.activeTabSVC = 'primary';
                this.activeTabSR = 'light';

                // ---- Show/Hide Count Flags Dynamically ----
                this.svcPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.svcPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }

                //Show hide flag
                // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                // this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SVC
                // if (subparams == 'All') {
                //     this.activeTabSVCAllFlag = (subparams == 'All') ? 'primary' : 'light';
                //     this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSVCP0Flag = (subparams == 'P0') ? 'primary' : 'light';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSVCP1Flag = (subparams == 'P1') ? 'primary' : 'light';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP2Flag = this.activeTabSVCSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSVCP2Flag = (subparams == 'P2') ? 'primary' : 'light';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCSameRouteFlag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP2);
                // } else if (subparams == 'SameRoute') {
                //     this.activeTabSVCSameRouteFlag = (subparams == 'SameRoute') ? 'primary' : 'light';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = 'light'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListSame_route);
                // }
            }

            this.showUnallocatedListFilter = [...this.showUnallocatedList];

        },

        /* New Mobile Allocation :- This api used for get pending shipment of SR / SVC */
        allocationPendingShipmentList() {
            this.refershcountandlist = false;
            let payloadobj = {
                "hubId": this.userHubId,
                "srId": this.SrId,
                "shipmentType": "Delivery",
                "type": this.setDashboardCountTabNameType,
                "requestedBy":this.createdBy,
                "requestFrom":"WEB"
            }

            getallocationPendingCountList(payloadobj, async(result) => {
                if (result.data.code == 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    this.showAllocatedShipmentsList = [];

                    // //Pending SR list & count Reset.
                    // this.setSRListAll = this.setSRListP0 = this.setSRListP1 = this.setSRListP2 = this.setSRListSame_route = [];
                    // this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = this.setSRCountSame_route = 0;
                    // // Pending SVC list & count Reset.
                    // this.setSVCListAll = this.setSVCListP0 = this.setSVCListP1 = this.setSVCListP2 = this.setSVCListSame_route = [];
                    // this.setSVCCountAll = this.setSVCCountP0 = this.setSVCCountP1 = this.setSVCCountP2 = this.setSVCCountSame_route = 0;
                    // //Allocated SR list & count Reset.
                    // this.setSRAllocatedListAll = this.setSRAllocatedListP0 = this.setSRAllocatedListP1 = this.setSRAllocatedListP2 = this.setSRAllocatedListSame_route = [];
                    // this.setSRAllocatedCountAll = this.setSRAllocatedCountP0 = this.setSRAllocatedCountP1 = this.setSRAllocatedCountP2 = this.setSRAllocatedCountSame_route = 0;
                    // // Allocated SVC list & count Reset.
                    // this.setSVCAllocatedListAll = this.setSVCAllocatedListP0 = this.setSVCAllocatedListP1 = this.setSVCAllocatedListP2 = this.setSVCAllocatedListSame_route = [];
                    // this.setSVCAllocatedCountAll = this.setSVCAllocatedCountP0 = this.setSVCAllocatedCountP1 = this.setSVCAllocatedCountP2 = this.setSVCAllocatedCountSame_route = 0;

                    if (this.setDashboardCountTabNameType == 'pending') {
                        let finalResult = result.data.data;
                        this.setCountSR = finalResult.sr.count;
                        this.setCountSVC = finalResult.svc.count;

                        this.pendingSrShipmentCount = finalResult.sr.count;
                        this.pendingSVCShipmentCount = finalResult.svc.count;
                        
                        if (finalResult.sr.list) {
                            this.srBlockFlag = true;
                            this.svcBlockFlag = false;
                            this.activeTabSR = 'primary';
                            this.activeTabSVC = 'light';

                            /* Updated Code here */
                            await this.updateDynamicType('sr', finalResult);
                            /* Updated Code Here */


                            // this.setSRCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                            // this.setSRCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                            // this.setSRCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                            // this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)
                            // this.setSRCountSame_route = (finalResult.sr.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSRCountSame_route;

                            // //Show hide flag
                            // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                            // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                            // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                            // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;
                            // this.setSRCountSame_routeFlag = (this.setSRCountSame_route > 0) ? true : false;

                            // //SR pending list
                            // if (finalResult.sr.list.P0) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P0]
                            //     this.setSRListP0 = [...this.setSRListP0, ...finalResult.sr.list.P0]
                            // }
                            // if (finalResult.sr.list.P1) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P1]
                            //     this.setSRListP1 = [...this.setSRListP1, ...finalResult.sr.list.P1]
                            // }
                            // if (finalResult.sr.list.P2) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P2]
                            //     this.setSRListP2 = [...this.setSRListP2, ...finalResult.sr.list.P2]
                            // }
                            // if (finalResult.sr.list.Same_route) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.Same_route]
                            //     this.setSRListSame_route = [...this.setSRListSame_route, ...finalResult.sr.list.Same_route]
                            // }
                        }
                        if (finalResult.svc.list) {
                            this.srBlockFlag = false;
                            this.svcBlockFlag = true;
                            this.activeTabSVC = 'primary';
                            this.activeTabSR = 'light';

                            /* Updated Code here */
                            await this.updateDynamicType('svc', finalResult);
                            await this.calculateAirWhiZShipment();
                            /* Updated Code Here */


                            // this.setSVCCountP0 = (finalResult.svc.list.P0) ? finalResult.svc.list.P0.length : this.setSVCCountP0;
                            // this.setSVCCountP1 = (finalResult.svc.list.P1) ? finalResult.svc.list.P1.length : this.setSVCCountP1;
                            // this.setSVCCountP2 = (finalResult.svc.list.P2) ? finalResult.svc.list.P2.length : this.setSVCCountP2;
                            // this.setSVCCountAll = parseInt(this.setSVCCountP0) + parseInt(this.setSVCCountP1) + parseInt(this.setSVCCountP2);
                            // this.setSVCCountSame_route = (finalResult.svc.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSVCCountSame_route;

                            // //Show hide flag
                            // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                            // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                            // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                            // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                            // this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                            // //SVC pending List
                            // if (finalResult.svc.list.P0) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P0]
                            //     this.setSVCListP0 = [...this.setSVCListP0, ...finalResult.svc.list.P0]
                            // }
                            // if (finalResult.svc.list.P1) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P1]
                            //     this.setSVCListP1 = [...this.setSVCListP1, ...finalResult.svc.list.P1]
                            // }
                            // if (finalResult.svc.list.P2) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P2]
                            //     this.setSVCListP2 = [...this.setSVCListP2, ...finalResult.svc.list.P2]
                            // }
                            // if (finalResult.svc.list.Same_route) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.Same_route]
                            //     this.setSVCListSame_route = [...this.setSVCListSame_route, ...finalResult.svc.list.Same_route]
                            // }
                        }

                        if (finalResult.sr.list) {
                            this.changeSelected('pendingsr', 'All')
                        } else if (finalResult.svc.list) {
                            this.changeSelected('pendingsvc', 'All')
                        }

                    } else {
                        let finalResult = result.data.data;
                        this.setCountSRAllocated = finalResult.sr.count;
                        this.setCountSVCAllocated = finalResult.svc.count;

                        this.allocateSrShipmentCount = finalResult.sr.count;
                        this.allocateSVCShipmentCount = finalResult.svc.count;

                        if (finalResult.sr.list) {
                            this.srAllocatedBlockFlag = true;
                            this.svcAllocatedBlockFlag = false;
                            this.activeTabSRAllocated = 'primary';
                            this.activeTabSVCAllocated = 'light';

                            /* Updated Code here */
                            await this.updateDynamicTypeAllocated('sr', finalResult);
                            /* Updated Code Here */


                            // this.setSRAllocatedCountP0 = (finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRAllocatedCountP0;
                            // this.setSRAllocatedCountP1 = (finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRAllocatedCountP1;
                            // this.setSRAllocatedCountP2 = (finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRAllocatedCountP2;
                            // this.setSRAllocatedCountAll = parseInt(this.setSRAllocatedCountP0) + parseInt(this.setSRAllocatedCountP1) + parseInt(this.setSRAllocatedCountP2)
                            // this.setSRAllocatedCountSame_route = (finalResult.sr.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSRAllocatedCountSame_route;

                            // //Show hide flag
                            // this.setSRAllocatedCountP0Flag = (this.setSRAllocatedCountP0 > 0) ? true : false;
                            // this.setSRAllocatedCountP1Flag = (this.setSRAllocatedCountP1 > 0) ? true : false;
                            // this.setSRAllocatedCountP2Flag = (this.setSRAllocatedCountP2 > 0) ? true : false;
                            // this.setSRAllocatedCountAllFlag = (this.setSRAllocatedCountAll > 0) ? true : false;
                            // this.setSRAllocatedCountSame_routeFlag = (this.setSRAllocatedCountSame_route > 0) ? true : false;

                            // //SRAllocated allocated list
                            // if (finalResult.sr.list.P0) {
                            //     this.setSRAllocatedListAll = [...this.setSRAllocatedListAll, ...finalResult.sr.list.P0]
                            //     this.setSRAllocatedListP0 = [...this.setSRAllocatedListP0, ...finalResult.sr.list.P0]
                            // }
                            // if (finalResult.sr.list.P1) {
                            //     this.setSRAllocatedListAll = [...this.setSRAllocatedListAll, ...finalResult.sr.list.P1]
                            //     this.setSRAllocatedListP1 = [...this.setSRAllocatedListP1, ...finalResult.sr.list.P1]
                            // }
                            // if (finalResult.sr.list.P2) {
                            //     this.setSRAllocatedListAll = [...this.setSRAllocatedListAll, ...finalResult.sr.list.P2]
                            //     this.setSRAllocatedListP2 = [...this.setSRAllocatedListP2, ...finalResult.sr.list.P2]
                            // }
                            // if (finalResult.sr.list.Same_route) {
                            //     this.setSRAllocatedListAll = [...this.setSRAllocatedListAll, ...finalResult.sr.list.Same_route]
                            //     this.setSRAllocatedListSame_route = [...this.setSRAllocatedListSame_route, ...finalResult.sr.list.Same_route]
                            // }
                        }
                        if (finalResult.svc.list) {
                            this.srAllocatedBlockFlag = false;
                            this.svcAllocatedBlockFlag = true;
                            this.activeTabSVCAllocated = 'primary';
                            this.activeTabSRAllocated = 'light';


                             /* Updated Code here */
                            await this.updateDynamicTypeAllocated('svc', finalResult);
                            /* Updated Code Here */


                            // this.setSVCAllocatedCountP0 = (finalResult.svc.list.P0) ? finalResult.svc.list.P0.length : this.setSVCAllocatedCountP0;
                            // this.setSVCAllocatedCountP1 = (finalResult.svc.list.P1) ? finalResult.svc.list.P1.length : this.setSVCAllocatedCountP1;
                            // this.setSVCAllocatedCountP2 = (finalResult.svc.list.P2) ? finalResult.svc.list.P2.length : this.setSVCAllocatedCountP2;
                            // this.setSVCAllocatedCountAll = parseInt(this.setSVCAllocatedCountP0) + parseInt(this.setSVCAllocatedCountP1) + parseInt(this.setSVCAllocatedCountP2);
                            // this.setSVCAllocatedCountSame_route = (finalResult.svc.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSVCAllocatedCountSame_route;

                            // //Show hide flag
                            // this.setSVCAllocatedCountP0Flag = (this.setSVCAllocatedCountP0 > 0) ? true : false;
                            // this.setSVCAllocatedCountP1Flag = (this.setSVCAllocatedCountP1 > 0) ? true : false;
                            // this.setSVCAllocatedCountP2Flag = (this.setSVCAllocatedCountP2 > 0) ? true : false;
                            // this.setSVCAllocatedCountAllFlag = (this.setSVCAllocatedCountAll > 0) ? true : false;
                            // this.setSVCAllocatedCountSame_routeFlag = (this.setSVCAllocatedCountSame_route > 0) ? true : false;

                            // //SVCAllocated allocated List
                            // if (finalResult.svc.list.P0) {
                            //     this.setSVCAllocatedListAll = [...this.setSVCAllocatedListAll, ...finalResult.svc.list.P0]
                            //     this.setSVCAllocatedListP0 = [...this.setSVCAllocatedListP0, ...finalResult.svc.list.P0]
                            // }
                            // if (finalResult.svc.list.P1) {
                            //     this.setSVCAllocatedListAll = [...this.setSVCAllocatedListAll, ...finalResult.svc.list.P1]
                            //     this.setSVCAllocatedListP1 = [...this.setSVCAllocatedListP1, ...finalResult.svc.list.P1]
                            // }
                            // if (finalResult.svc.list.P2) {
                            //     this.setSVCAllocatedListAll = [...this.setSVCAllocatedListAll, ...finalResult.svc.list.P2]
                            //     this.setSVCAllocatedListP2 = [...this.setSVCAllocatedListP2, ...finalResult.svc.list.P2]
                            // }
                            // if (finalResult.svc.list.Same_route) {
                            //     this.setSVCAllocatedListAll = [...this.setSVCAllocatedListAll, ...finalResult.svc.list.Same_route]
                            //     this.setSVCAllocatedListSame_route = [...this.setSVCAllocatedListSame_route, ...finalResult.svc.list.Same_route]
                            // }
                        }

                        if (finalResult.sr.list) {
                            this.changeSelectedAllocation('allocatedsr', 'All')
                        } else if (finalResult.svc.list) {
                            this.changeSelectedAllocation('allocatedsvc', 'All')
                        }
                    }
                    try {
                        let TrackerInfo = {
                            projectname: "Last Mile",
                            type: "Web",
                            routeurl: "allocation/shipmentlist",
                            userid: this.userid,
                            username: this.createdBy,
                            meta: {
                                event: "allocation-shipmentlist",
                                shipmentId: null,
                                remarks: "FrontEnd",
                                hubId: payloadobj ? (payloadobj.hubId ? payloadobj.hubId : null) : null
                            },
                        }
                        Object.assign(TrackerInfo.meta, payloadobj);
                        this.PageTracker(TrackerInfo);
                    } catch (error) {
                        console.log(error);
                    }
                } else if ([110, 500].includes(result.data.status)) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                    this.$alertify.error(result.data.msg + " Please try again...!");
                } else if (result.data.code != 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }
            })
        },

        changeSelectedAllocation(params, subparams) {
            this.showUnallocatedList = [];
            this.showAllocatedShipmentsList = [];
            let upperType = params === 'allocatedsr' ? 'SR' : 'SVC';
            if (params == 'allocatedsr') {
                this.srAllocatedBlockFlag = true;
                this.svcAllocatedBlockFlag = false;
                this.activeTabSRAllocated = 'primary';
                this.activeTabSVCAllocated = 'light';

                // ---- Show/Hide SR Count Flags ----
                this.srAllocatedPriorities.forEach(key => {
                    this[`set${upperType}AllocatedCount${key}Flag`] = this[`set${upperType}AllocatedCount${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.srAllocatedPriorities.forEach(key => {
                    this[`activeTab${upperType}Allocated${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}Allocated${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}AllocatedList${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showAllocatedShipmentsList = [...this.showAllocatedShipmentsList, ...this[listKey]];
                }

                //Show hide flag
                // this.setSRAllocatedCountP0Flag = (this.setSRAllocatedCountP0 > 0) ? true : false;
                // this.setSRAllocatedCountP1Flag = (this.setSRAllocatedCountP1 > 0) ? true : false;
                // this.setSRAllocatedCountP2Flag = (this.setSRAllocatedCountP2 > 0) ? true : false;
                // this.setSRAllocatedCountAllFlag = (this.setSRAllocatedCountAll > 0) ? true : false;
                // this.setSRAllocatedCountSame_routeFlag = (this.setSRAllocatedCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SRAllocated
                // if (subparams == 'All') {
                //     this.activeTabSRAllocatedAllFlag = (subparams == 'All') ? 'primary' : 'light';
                //     this.activeTabSRAllocatedP0Flag = this.activeTabSRAllocatedP1Flag = this.activeTabSRAllocatedP2Flag = this.activeTabSRAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSRAllocatedListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSRAllocatedP0Flag = (subparams == 'P0') ? 'primary' : 'light';
                //     this.activeTabSRAllocatedAllFlag = this.activeTabSRAllocatedP1Flag = this.activeTabSRAllocatedP2Flag = this.activeTabSRAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSRAllocatedListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSRAllocatedP1Flag = (subparams == 'P1') ? 'primary' : 'light';
                //     this.activeTabSRAllocatedAllFlag = this.activeTabSRAllocatedP0Flag = this.activeTabSRAllocatedP2Flag = this.activeTabSRAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSRAllocatedListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSRAllocatedP2Flag = (subparams == 'P2') ? 'primary' : 'light';
                //     this.activeTabSRAllocatedAllFlag = this.activeTabSRAllocatedP0Flag = this.activeTabSRAllocatedP1Flag = this.activeTabSRAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSRAllocatedListP2);
                // } else if (subparams == 'SameRoute') {
                //     this.activeTabSRAllocatedSameRouteFlag = (subparams == 'SameRoute') ? 'primary' : 'light';
                //     this.activeTabSRAllocatedAllFlag = this.activeTabSRAllocatedP0Flag = this.activeTabSRAllocatedP1Flag = this.activeTabSRAllocatedP2Flag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSRAllocatedListSame_route);
                // }



            } else if (params == 'allocatedsvc') {
                this.srAllocatedBlockFlag = false;
                this.svcAllocatedBlockFlag = true;
                this.activeTabSVCAllocated = 'primary';
                this.activeTabSRAllocated = 'light';

                // ---- Show/Hide SVC Count Flags ----
                this.svcAllocatedPriorities.forEach(key => {
                    this[`set${upperType}AllocatedCount${key}Flag`] = this[`set${upperType}AllocatedCount${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.svcAllocatedPriorities.forEach(key => {
                    this[`activeTab${upperType}Allocated${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}Allocated${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}AllocatedList${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showAllocatedShipmentsList = [...this.showAllocatedShipmentsList, ...this[listKey]];
                }

                //Show hide flag
                // this.setSVCAllocatedCountP0Flag = (this.setSVCAllocatedCountP0 > 0) ? true : false;
                // this.setSVCAllocatedCountP1Flag = (this.setSVCAllocatedCountP1 > 0) ? true : false;
                // this.setSVCAllocatedCountP2Flag = (this.setSVCAllocatedCountP2 > 0) ? true : false;
                // this.setSVCAllocatedCountAllFlag = (this.setSVCAllocatedCountAll > 0) ? true : false;
                // this.setSVCAllocatedCountSame_routeFlag = (this.setSVCAllocatedCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SVCAllocated
                // if (subparams == 'All') {
                //     this.activeTabSVCAllocatedAllFlag = (subparams == 'All') ? 'primary' : 'light';
                //     this.activeTabSVCAllocatedP0Flag = this.activeTabSVCAllocatedP1Flag = this.activeTabSVCAllocatedP2Flag = this.activeTabSVCAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSVCAllocatedListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSVCAllocatedP0Flag = (subparams == 'P0') ? 'primary' : 'light';
                //     this.activeTabSVCAllocatedAllFlag = this.activeTabSVCAllocatedP1Flag = this.activeTabSVCAllocatedP2Flag = this.activeTabSVCAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSVCAllocatedListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSVCAllocatedP1Flag = (subparams == 'P1') ? 'primary' : 'light';
                //     this.activeTabSVCAllocatedAllFlag = this.activeTabSVCAllocatedP0Flag = this.activeTabSVCAllocatedP2Flag = this.activeTabSVCAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSVCAllocatedListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSVCAllocatedP2Flag = (subparams == 'P2') ? 'primary' : 'light';
                //     this.activeTabSVCAllocatedAllFlag = this.activeTabSVCAllocatedP0Flag = this.activeTabSVCAllocatedP1Flag = this.activeTabSVCAllocatedSameRouteFlag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSVCAllocatedListP2);
                // } else if (subparams == 'SameRoute') {
                //     this.activeTabSVCAllocatedSameRouteFlag = (subparams == 'SameRoute') ? 'primary' : 'light';
                //     this.activeTabSVCAllocatedAllFlag = this.activeTabSVCAllocatedP0Flag = this.activeTabSVCAllocatedP1Flag = this.activeTabSVCAllocatedP2Flag = 'light'
                //     this.showAllocatedShipmentsList = [].concat(...this.showAllocatedShipmentsList, this.setSVCAllocatedListSame_route);
                // }
            }
        },
        filterPendingList() {
            let clientNameSearch = '';
            let serviceTypeSearch = '';
            let EscalationSearch = '';
            let weightgroupSearch = '';
            let clusterSearch = '';
            let shippingIDSearch = '';
            let Motsearch = '';
            clientNameSearch = this.ClientObj.value;
            serviceTypeSearch = this.ServiceTypeObj.text;
            EscalationSearch = this.EscalationObj.text;
            clusterSearch = this.ClusterObj.text;
            if (this.WeightGObj.text && this.WeightGObj.text.trim() == 'Heavies') {
                weightgroupSearch = true;
            } else if (this.WeightGObj.text && this.WeightGObj.text.trim() == 'Reguler') {
                weightgroupSearch = false;
            }
            shippingIDSearch = this.AccAWBNumbers;
            Motsearch = this.MOTObj.text;

            let searchObj = {};
            if (clientNameSearch) { searchObj.ClientId = clientNameSearch }
            if (serviceTypeSearch) { searchObj.ServiceType = serviceTypeSearch }
            if (EscalationSearch) { searchObj.NotificationStatus = EscalationSearch }
            if (clusterSearch) { searchObj.subclustername = clusterSearch }
            if (weightgroupSearch != '') { searchObj.isheavies = weightgroupSearch }
            if (shippingIDSearch) { searchObj.ShippingID = shippingIDSearch }
            if (Motsearch) { searchObj.MOT = Motsearch}
            
            let filteredObjects = this.searchObjects(this.showUnallocatedListFilter, searchObj);
            this.showUnallocatedList = filteredObjects;            
        },
        cantAllocate() {
            this.cantallocatebtn = false;
            this.isCantallocate = true;
            this.cancelResaonBtnText = 'Proceed';
            this.submitreasonbtn = true;
            this.buttonVariant = 'danger';
        },
        searchObjects(objects, criteria) {
            return objects.filter(obj => {
                for (let key in criteria) {
                    if (obj[key] !== criteria[key]) {
                        return false;
                    }
                }
                return true;
            });
        },
        shipmentInfo() {
            this.shipmentInfoFlag = true
        },
        CloseshipmentInfoFlag() {
            this.shipmentInfoFlag = false
        },

        /* Updated Code here */
        updateDynamicType(type, finalResult) {
            let list = finalResult[type].list;
            let upper = type.toUpperCase();

            // Always initialize master list
            if (!this[`set${upper}ListAll`]) this.$set(this, `set${upper}ListAll`, []);

            if (list) {
                let keys = Object.keys(list);

                // Ensure priorities exist

                this[`${type}Priorities`] = [
                'All',
                ...new Set(
                    keys
                    .filter(p => p)
                    .sort((a, b) => {
                        // sort priorities like P0, P1, P2 numerically
                        let numA = parseInt(a.replace(/\D/g, '')) || 0;
                        let numB = parseInt(b.replace(/\D/g, '')) || 0;
                        return numA - numB;
                    })
                )
                ];

                // ✅ Reset all arrays & counts for this type before reassigning
                this[`set${upper}ListAll`] = [];
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    // Initialize reactivity if missing
                    if (!(listProp in this)) this.$set(this, listProp, []);
                    if (!(countProp in this)) this.$set(this, countProp, 0);
                    if (!(flagProp in this)) this.$set(this, flagProp, false);

                    // ✅ Reset existing data before filling
                    this[listProp] = [];
                    this[countProp] = 0;
                    this[flagProp] = false;
                });

                // Fill the lists dynamically
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    let items = Array.isArray(list[priority]) ? list[priority] : [];

                    this[countProp] = items.length;
                    this[flagProp] = items.length > 0;

                    if (items.length) {
                        this[listProp] = [...items];
                        this[`set${upper}ListAll`] = [...this[`set${upper}ListAll`], ...items];
                    }
                });

                // Calculate total counts
                let total = keys.reduce((acc, k) => acc + (Number(this[`set${upper}Count${k}`]) || 0), 0);

                if (!(`set${upper}CountAll` in this)) this.$set(this, `set${upper}CountAll`, 0);
                if (!(`set${upper}CountAllFlag` in this)) this.$set(this, `set${upper}CountAllFlag`, false);

                this[`set${upper}CountAll`] = total;
                this[`set${upper}CountAllFlag`] = total > 0;
            }
        },

        updateDynamicTypeAllocated(type, finalResult) {
            let list = finalResult[type].list;
            let upper = type.toUpperCase();

            // Always initialize master list
            if (!this[`set${upper}AllocatedListAll`]) this.$set(this, `set${upper}AllocatedListAll`, []);

            if (list) {
                let keys = Object.keys(list);

                // Ensure priorities exist

                this[`${type}AllocatedPriorities`] = [
                'All',
                ...new Set(
                    keys
                    .filter(p => p)
                    .sort((a, b) => {
                        // sort priorities like P0, P1, P2 numerically
                        let numA = parseInt(a.replace(/\D/g, '')) || 0;
                        let numB = parseInt(b.replace(/\D/g, '')) || 0;
                        return numA - numB;
                    })
                )
                ];

                // ✅ Reset all arrays & counts for this type before reassigning
                this[`set${upper}AllocatedListAll`] = [];
                keys.forEach(priority => {
                    let listProp = `set${upper}AllocatedList${priority}`;
                    let countProp = `set${upper}AllocatedCount${priority}`;
                    let flagProp = `set${upper}AllocatedCount${priority}Flag`;

                    // Initialize reactivity if missing
                    if (!(listProp in this)) this.$set(this, listProp, []);
                    if (!(countProp in this)) this.$set(this, countProp, 0);
                    if (!(flagProp in this)) this.$set(this, flagProp, false);

                    // ✅ Reset existing data before filling
                    this[listProp] = [];
                    this[countProp] = 0;
                    this[flagProp] = false;
                });

                // Fill the lists dynamically
                keys.forEach(priority => {
                    let listProp = `set${upper}AllocatedList${priority}`;
                    let countProp = `set${upper}AllocatedCount${priority}`;
                    let flagProp = `set${upper}AllocatedCount${priority}Flag`;

                    let items = Array.isArray(list[priority]) ? list[priority] : [];

                    this[countProp] = items.length;
                    this[flagProp] = items.length > 0;

                    if (items.length) {
                        this[listProp] = [...items];
                        this[`set${upper}AllocatedListAll`] = [...this[`set${upper}AllocatedListAll`], ...items];
                    }
                });

                // Calculate total counts
                let total = keys.reduce((acc, k) => acc + (Number(this[`set${upper}AllocatedCount${k}`]) || 0), 0);

                if (!(`set${upper}AllocatedCountAll` in this)) this.$set(this, `set${upper}AllocatedCountAll`, 0);
                if (!(`set${upper}AllocatedCountAllFlag` in this)) this.$set(this, `set${upper}AllocatedCountAllFlag`, false);

                this[`set${upper}AllocatedCountAll`] = total;
                this[`set${upper}AllocatedCountAllFlag`] = total > 0;
            }
        },

        /** Return dynamic count 
            dynamic count getter */
        getSRCount(type, priority) {
            return this[`set${type}Count${priority}`] || 0;
        },

        // dynamic flag getter
        getSRFlag(type, priority) {
            return this[`set${type}Count${priority}Flag`] || false;
        },

        // dynamic button active variant
        getSRVariant(type, priority) {
            return this[`activeTab${type}${priority}Flag`] || 'secondary';
        },


        getSRAllocatedCount(type, priority) {
            return this[`set${type}AllocatedCount${priority}`] || 0;
        },

        // dynamic flag getter
        getSRAllocatedFlag(type, priority) {
            return this[`set${type}AllocatedCount${priority}Flag`] || false;
        },

        // dynamic button active variant
        getSRAllocatedVariant(type, priority) {
            return this[`activeTab${type}Allocated${priority}Flag`] || 'secondary';
        },

        // label formatting
        formatPriorityLabel(priority) {
            if (priority === "Same_route" || priority === "SameRoute") return "Same Route";
            return priority; // P0, P1, P2...
        },

        selfPickupClientDialog() {
            let message = {
                title: '',
                body:
                  `<div style="text-align: center;">
                <p><strong>This shipment is for self-pickup and should be allocated only while handing over.</strong></p>
                <p><strong>Are you sure you want to allocate?</strong></p>
            </div>`
            };

            let res = this.$dialog.confirm(message, {
                html: true,
                animation: 'bounce',
                backdropClose: false,
                okText: 'Yes',
                cancelText: 'No',
                reverse: false,
                loader: true
            })
                .then(dialog => {
                    this.AllocateLoading = true;
                    this.clientcheck = true;
                    this.triggeredByDialog = true;
                    this.Allocate();
                    dialog.close()


                })
                .catch();
        },
           selectMOT(obj) {
            this.MOTObj = obj;
            this.MOT = obj.text
        },
        async calculateAirWhiZShipment() {
            this.MOTList = [...new Set(this[`setSVCListAll`].map(item => item.MOT).filter(mot => mot))].map(mot => ({ text: mot }));

            this.WHIZshipmentcount = 0;
            this.airshipmentscount = 0;

            this[`setSVCListAll`].forEach(item => {
                if (item.ServiceType === 'WHIZ') {
                    this.WHIZshipmentcount++;
                }
                else if (item.MOT === 'Air' && item.ServiceType !== 'WHIZ') {
                    this.airshipmentscount++;
                }
            });

            this.$emit('update-air-count', this.airshipmentscount);
            this.$emit('update-airwiz-count', this.WHIZshipmentcount);
        }
    }
};


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/forwardallocation/forwardallocation.js